import { render, staticRenderFns } from "./BusinessInterest.vue?vue&type=template&id=12013a26&"
import script from "./BusinessInterest.vue?vue&type=script&lang=js&"
export * from "./BusinessInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports